<template>
    <div class="view-invoices-page">
        <base-header
            class="warehouse-main-page__header"
            :titulo="translate('new_record.main_title')"
            :voltarPara='true'
        />
        <div class="view-container-wrapper">
            <div class="content">
                <search-filters @changeFilters="changeFilters" />
                <totalizers v-if="filters.length !== 0" />
                <file-list
                    v-if="filters.length !== 0"
                    :filters="filters"
                />
            </div>
        </div>
    </div>
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import SearchFilters from '@/modules/warehouse/views/pages/viewBatchRecord/components/filters/index.vue';
import Totalizers from '@/modules/warehouse/views/pages/viewBatchRecord/components/totalizers/index.vue';
import FileList from '@/modules/warehouse/views/pages/viewBatchRecord/components/file-list/index.vue';

export default {
    name: 'ViewProcessingInvoicesPage',
    components: {
        BaseHeader,
        SearchFilters,
        Totalizers,
        FileList
    },
    computed: {
    },
    mounted() {},
    data() {
        return {
            filters: {}
        };
    },
    methods: {
        translate(key, params = {}) {
            const base = 'warehouse';
            return this.$t(`${base}.${key}`, params);
        },

        changeFilters(filters) {
            this.filters = filters;
        }
    }
};
</script>

<style scoped lang="scss">
.view-invoices-page {
    .view-container-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 16px;
    }
}
</style>
